import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const KEY = "legend_cookie_consent";

const TXT = {
  it: { title: "Cookie e pubblicità", body: "Usiamo cookie di Google Ads per misurare le visite e migliorare la pubblicità. Puoi accettare o rifiutare: il sito funziona comunque.", more: "Privacy & Cookie Policy", accept: "Accetta", reject: "Rifiuta" },
  en: { title: "Cookies & advertising", body: "We use Google Ads cookies to measure visits and improve advertising. You can accept or reject: the site works either way.", more: "Privacy & Cookie Policy", accept: "Accept", reject: "Reject" },
};

function setConsent(granted) {
  const v = granted ? "granted" : "denied";
  window.gtag?.("consent", "update", { ad_storage: v, analytics_storage: v, ad_user_data: v, ad_personalization: v });
}

export const openCookieSettings = () => window.dispatchEvent(new Event("open-cookie-settings"));

export default function CookieConsent() {
  const { lang } = useLang();
  const t = TXT[lang] || TXT.it;
  const location = useLocation();
  const [open, setOpen] = useState(() => !localStorage.getItem(KEY));

  useEffect(() => {
    window.gtag?.("event", "page_view", { page_title: document.title, page_location: window.location.href, page_path: location.pathname + location.search });
  }, [location.pathname, location.search]);

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener("open-cookie-settings", show);
    return () => window.removeEventListener("open-cookie-settings", show);
  }, []);

  const choose = (accepted) => {
    localStorage.setItem(KEY, accepted ? "accepted" : "rejected");
    setConsent(accepted);
    setOpen(false);
  };

  if (!open) return null;
  return (
    <div role="dialog" aria-label={t.title} data-testid="cookie-banner" className="fixed inset-x-0 bottom-14 md:bottom-0 z-[70] p-3 md:p-4">
      <div className="max-w-4xl mx-auto bg-legend-ink text-white border-2 border-legend-red shadow-2xl p-4 md:p-5 flex flex-col md:flex-row md:items-center gap-4">
        <Cookie className="text-legend-red shrink-0 hidden md:block" size={32} />
        <div className="flex-1 min-w-0">
          <p className="font-display font-black uppercase tracking-wide text-sm">{t.title}</p>
          <p className="text-xs md:text-sm text-white/80 mt-1">
            {t.body} <Link to="/privacy" data-testid="cookie-banner-privacy-link" className="underline hover:text-legend-red">{t.more}</Link>
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <button type="button" data-testid="cookie-reject-btn" onClick={() => choose(false)} className="flex-1 md:flex-none px-5 py-2.5 border-2 border-white/70 font-bold uppercase text-xs tracking-wide hover:bg-white hover:text-legend-ink transition-colors">{t.reject}</button>
          <button type="button" data-testid="cookie-accept-btn" onClick={() => choose(true)} className="flex-1 md:flex-none px-5 py-2.5 bg-legend-red border-2 border-legend-red font-bold uppercase text-xs tracking-wide hover:brightness-110 transition-[filter]">{t.accept}</button>
        </div>
      </div>
    </div>
  );
}
